import Fetcher from '../util/Fetcher';
import { handleInteractionTypesResponse } from './callHandlers';
export var interactionTypeFetch = function interactionTypeFetch() {
  var url = '/api/interaction_types';
  var fetcher = new Fetcher();
  return function (dispatch, getState) {
    return fetcher.get(url).then(function (interactionTypesData) {
      dispatch(handleInteractionTypesResponse(interactionTypesData));
    });
  };
};